module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "content-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.$t('pages.hamlet_users.add_user')) + "\n    ")])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }]
  }, [_c('el-table', {
    attrs: {
      "data": _vm.users
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "100",
      "label": _vm.$t('pages.hamlet_users.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "width": "130",
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "min-width": "150",
      "label": _vm.$t('pages.hamlet_users.email')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "label": _vm.$t('pages.hamlet_users.applications'),
      "formatter": _vm.joinAppsName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_at",
      "width": "160",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.last_login_at'),
      "formatter": _vm.formatDatetime
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.status) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thirdparty_users",
      "min-width": "100",
      "label": _vm.$t('pages.hamlet_users.thirdparty_users')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((Object.keys(scope.row.thirdparty_users)), function(type) {
          return _c('el-popover', {
            key: type,
            attrs: {
              "placement": "right",
              "trigger": "click"
            }
          }, [_c('el-button', {
            key: type,
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_vm._v("\n              " + _vm._s(_vm.$t('common.' + type)) + "\n            ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(scope.row.thirdparty_users[type]))])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('common.operation'),
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editUserApps(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.edit')) + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.resetPassword(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.resetPassword')) + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(("common." + (scope.row.is_active ? 'forbid' : 'active')))) + "\n          ")]), _vm._v(" "), (scope.row.is_locked) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.unlockUser(scope.row.id)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.unlock')) + "\n          ")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('common.edit')
    },
    model: {
      value: (_vm.edit),
      callback: function($$v) {
        _vm.edit = $$v
      },
      expression: "edit"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.userApps,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.userApps.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.applications')
    }
  }, [(_vm.apps.length) ? _c('el-checkbox-group', {
    model: {
      value: (_vm.userApps.app_ids),
      callback: function($$v) {
        _vm.$set(_vm.userApps, "app_ids", $$v)
      },
      expression: "userApps.app_ids"
    }
  }, _vm._l((_vm.apps), function(app) {
    return (app.name !== 'Hamlet') ? _c('el-checkbox', {
      key: app.id,
      attrs: {
        "label": app.id
      }
    }, [_vm._v("\n            " + _vm._s(app.name) + "\n          ")]) : _vm._e()
  }), 1) : _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('pages.hamlet_users.no_apps')) + "\n        ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.authorizeAppManager
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.hamlet_users.add_user')
    },
    on: {
      "close": _vm.resetAdd
    },
    model: {
      value: (_vm.add),
      callback: function($$v) {
        _vm.add = $$v
      },
      expression: "add"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addUser,
      "rules": _vm.addUserRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkUsername
    },
    model: {
      value: (_vm.addUser.username),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "username", $$v)
      },
      expression: "addUser.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkEmail
    },
    model: {
      value: (_vm.addUser.email),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "email", $$v)
      },
      expression: "addUser.email"
    }
  })], 1), _vm._v(" "), (!_vm.usernameIsExist && !_vm.emailIsExist) ? [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUser.password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "password", $$v)
      },
      expression: "addUser.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.random_password')) + "\n              ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitAddUser($event)
      }
    },
    model: {
      value: (_vm.addUser.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "confirm_password", $$v)
      },
      expression: "addUser.confirm_password"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": !this.addUser.username && !this.addUser.email,
      "type": "primary"
    },
    on: {
      "click": _vm.submitAddUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('common.resetPassword')
    },
    on: {
      "close": _vm.resetPasswordForm
    },
    model: {
      value: (_vm.reset),
      callback: function($$v) {
        _vm.reset = $$v
      },
      expression: "reset"
    }
  }, [_c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.userReset,
      "rules": _vm.resetPasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.userReset.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "password", $$v)
      },
      expression: "userReset.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.random_password')) + "\n          ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitResetPassword($event)
      }
    },
    model: {
      value: (_vm.userReset.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "confirm_password", $$v)
      },
      expression: "userReset.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitResetPassword
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b1c46b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HamletUsers.vue
// module id = 387
// module chunks = 1